import { useState } from "react";
import { AnimatePresence, motion } from "framer-motion";
import { ChevronDown } from "lucide-react";

export default function Faq({ items, testidPrefix = "faq" }) {
  const [open, setOpen] = useState(0);
  return (
    <div className="divide-y divide-edge border border-edge rounded-2xl overflow-hidden bg-panel" data-testid={`${testidPrefix}-list`}>
      {items.map((f, i) => (
        <div key={i}>
          <button
            onClick={() => setOpen(open === i ? -1 : i)}
            data-testid={`${testidPrefix}-question-${i}`}
            aria-expanded={open === i}
            className="w-full flex items-center justify-between gap-4 px-5 py-4 text-start hover:bg-panel2 transition-colors"
          >
            <span className="font-bold text-white text-sm sm:text-base">{f.q}</span>
            <ChevronDown
              size={18}
              className={`text-gold shrink-0 transition-transform duration-300 ${open === i ? "rotate-180" : ""}`}
            />
          </button>
          <AnimatePresence initial={false}>
            {open === i && (
              <motion.div
                initial={{ height: 0, opacity: 0 }}
                animate={{ height: "auto", opacity: 1 }}
                exit={{ height: 0, opacity: 0 }}
                transition={{ duration: 0.28, ease: [0.22, 1, 0.36, 1] }}
                className="overflow-hidden"
              >
                <p className="px-5 pb-5 text-sm text-gray-300 leading-relaxed">{f.a}</p>
              </motion.div>
            )}
          </AnimatePresence>
        </div>
      ))}
    </div>
  );
}
